"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = void 0;
exports.build_data = { "build_version": "3.3.13.6", "build_date": "2025-10-07T14:16:43.557Z", "build_branch": "development", "build_commit": "0ad9071a0c506f839d6de5058bf997ca27c62265" };
//# sourceMappingURL=build_data.js.map